import React, { useCallback, useEffect, useState } from 'react';
import CardWithHeader from 'components/base/card-with-header';
import { FilterAltIcon } from 'cokitchen-icons';
import { apiService } from 'services/base.service';
import { useParams } from 'react-router-dom';
import ActivityIndicator from 'components/base/loader/activityIndicator';
import { formatCurrency, handleApiError } from 'utils/functions';

const StoreItems = () => {
  const [isFetchingVendorIngredients, setIsFetchingVendorIngredients] = useState(false);
  const [vendorIngredients, setVendorIngredients] = useState<
    { id: string; name: string; price: string; unit_type: string; vendor_id: string }[]
  >([]);
  const { id } = useParams();

  const PAGE_SIZE = 20;

  const fetchVendorIngredients = async (page: number) => {
    try {
      const response = await apiService.get(`vendors/ingredients`, {
        version: 'v2',
        params: { vendor_id: id, page, page_size: PAGE_SIZE }
      });
      if (response.data.data) {
        const mappedData = response.data.data
          .map((vendor_ingredient: any) => {
            if (!vendor_ingredient.ingredient) return null;
            return {
              id: vendor_ingredient.id,
              name: vendor_ingredient.ingredient.name || 'N/A',
              price: formatCurrency(Number(vendor_ingredient.gram_price)),
              unit_type: vendor_ingredient.ingredient.unit_type || 'gram',
              vendor_id: vendor_ingredient.vendor_id
            };
          })
          .filter(Boolean);

        setVendorIngredients((prev) => [...prev, ...mappedData]);
        return response.data.pagination?.total ?? 0;
      }
    } catch (error) {
      handleApiError(error);
    }
  };

  const fetchAllVendorIngredients = useCallback(async () => {
    setIsFetchingVendorIngredients(true);
    setVendorIngredients([]);

    try {
      const total = await fetchVendorIngredients(1);

      if (total > PAGE_SIZE) {
        const totalPages = Math.ceil(total / PAGE_SIZE);

        for (let page = 2; page <= totalPages; page++) {
          await fetchVendorIngredients(page);
        }
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsFetchingVendorIngredients(false);
    }
  }, [id]);

  useEffect(() => {
    fetchAllVendorIngredients();
  }, [fetchAllVendorIngredients]);
  return (
    <CardWithHeader
      title='Store items'
      rightSection={
        <FilterAltIcon className='w-[34px] h-[34px] text-[#96999C] rounded-full flex items-center justify-center p-[6px] border border-[#EFF0F0]' />
      }>
      <div className='space-y-5 mt-2'>
        {isFetchingVendorIngredients ? (
          <div>
            <ActivityIndicator />
          </div>
        ) : vendorIngredients.length > 0 ? (
          vendorIngredients.map((vendor_ingredient) => {
            return (
              <div key={vendor_ingredient.id} className={`flex items-center gap-4`}>
                <label className='grow  text-[#2E3031] '>{vendor_ingredient.name}</label>
                <p className='text-gray-9 text-sm font-medium'>
                  {vendor_ingredient.price}/{vendor_ingredient.unit_type}
                </p>
              </div>
            );
          })
        ) : (
          <h4 className='text-center text-sm'>No result</h4>
        )}
      </div>
    </CardWithHeader>
  );
};

export default StoreItems;
